import React, { Component } from "react";
import "./TicketMaster.css";
import Modalcomp from "../../helpers/ModalComp/Modalcomp";
import Paper from "@material-ui/core/Paper";
import TicketTable from "./TicketTable";
import i18n from "../../i18n/i18n";
import { withTranslation } from 'react-i18next';

class TicketMaster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      
    };
  }
  
  render() {
    const {t} = this.props
    return (
      <div className={`${this.props.i18n.language=='ar'?"arabic_cls":""} ticketmaster`}>
        <Paper>
          
              <TicketTable t={t} i18n={this.props.i18n}></TicketTable>
          {/* <MediaServiceTable
            getTableData={this.state.getTableDataopen}
            getTableDatafalse={this.getTableData}
            searchData={this.state.Search}
          /> */}
        </Paper>
        
      </div>
    );
  }
}
export default withTranslation()(TicketMaster);
